const Royal = {
  royal: {
    main: '#167286',
    light: '#50C0DA',
    dark: '#0A3848',
    '10': '#0A3848',
    '20': '#07475D',
    '30': '#035E72',
    '40': '#167286',
    '50': '#00819E',
    '60': '#1CA4C2',
    '70': '#50C0DA',
    '80': '#83DBEF',
    '90': '#B3E9F5',
    '95': '#DAF8FF',
    '99': '#EEFCFF',
  },
};

export default Royal;
